import React from 'react';
import WizardForm from 'react-step-wizard';
import merge from 'classnames';

import { StepperHeader } from './StepperHeader';
import { StepperProps as Props } from './types';

import styles from './Stepper.module.scss';

export const Stepper = ({
  headerSteps,
  initialStep,
  onStepChange,
  classes,
  children,
  submitInProgress,
}: Props) => {
  return (
    <div className={styles.stepper_wrapper} data-testid="stepper-wrapper">
      <WizardForm
        className={merge(styles.wizard_form, classes?.form)}
        initialStep={initialStep}
        nav={
          <StepperHeader
            className={classes?.header}
            steps={headerSteps}
            submitInProgress={submitInProgress}
          />
        }
        onStepChange={onStepChange}
        transitions={{}}
      >
        {children}
      </WizardForm>
    </div>
  );
};
